module.exports = __webpack_public_path__ + "static/gallery_yarra_6_thumb-7675a9c726c573c1b4fff3d2f99b9fe5.jpg";